import React from "react";
import ReactDOM from "react-dom";
import "./CSS/index.css";
import App from "./Components/App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import TimeAgo from "javascript-time-ago";

import en from "javascript-time-ago/locale/en.json";
import ru from "javascript-time-ago/locale/ru.json";

TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(ru);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
